import React from 'react';
import MetricCard, { MetricCardProps } from './MetricCard';
import styles from './VCUpdatesPage.module.css';

interface MetricsGridProps {
  metrics: MetricCardProps[];
}

const MetricsGrid: React.FC<MetricsGridProps> = ({ metrics }) => {
  // Don't render if no metrics
  if (!metrics || metrics.length === 0) {
    return null;
  }

  return (
    <div className={styles.metricsGrid}>
      {metrics.map((metric, idx) => (
        <MetricCard key={idx} {...metric} />
      ))}
    </div>
  );
};

export default MetricsGrid;

